/**
 * Wat een niveau kost als je het afkoopt (SPEC §3).
 *
 * Afkopen is de jaren die het niveau vraagt in één keer betalen, **inclusief
 * de jaarbijdrage van het lopende jaar**. Zilver vraagt drie volle jaren
 * (drempel 4 min één), dus zilver afkopen kost drie jaarbijdragen; wie zich
 * aanmeldt betaalt dan niet € 100 + € 300 maar € 300 in totaal. Goud kost
 * vijf. De opstap van zilver naar goud is het verschil: twee.
 *
 * Daarmee is afkopen nooit goedkoper dan wachten, en in het eerste jaar even
 * duur; het verschil zit erin dat de jaarbijdrage daarna gewoon doorloopt
 * (besluit van het bestuur: afkopen is een niveau kopen, geen jaren
 * vooruitbetalen).
 *
 * Alles schaalt met de **jaarbijdrage van de held zelf**: een bedrijf met een
 * tarief van € 250 koopt zilver voor € 750, en wie vrijwillig € 150 per jaar
 * geeft voor € 450. Er zijn dus geen losse afkoopprijzen meer in de
 * instellingen; de drempels en het tarief bepalen alles.
 */

import type { Drempels, Niveau } from './niveau';

/** Hoeveel jaarbijdragen een niveau in totaal vertegenwoordigt. */
export function jarenVoorNiveau(drempels: Drempels, niveau: Niveau): number {
  if (niveau === 'goud') return Math.max(1, drempels.goudNaJaren - 1);
  if (niveau === 'zilver') return Math.max(1, drempels.zilverNaJaren - 1);
  return 1;
}

/** De totaalprijs van een niveau, inclusief het lopende jaar. */
export function afkoopTotaal(drempels: Drempels, jaarbedragCent: number, niveau: Niveau): number {
  return jarenVoorNiveau(drempels, niveau) * jaarbedragCent;
}

/**
 * Wat er **extra** betaald moet worden, bovenop wat de held dit jaar al
 * betaalt of betaald heeft: vanaf brons de totaalprijs min één jaarbijdrage,
 * vanaf zilver het verschil tussen goud en zilver.
 */
export function afkoopExtra(drempels: Drempels, jaarbedragCent: number, huidig: Niveau, gewenst: Niveau): number {
  const totaal = afkoopTotaal(drempels, jaarbedragCent, gewenst);
  const alBetaald = huidig === 'zilver' ? afkoopTotaal(drempels, jaarbedragCent, 'zilver') : jaarbedragCent;
  return Math.max(0, totaal - alBetaald);
}
